import {
  DeleteJobCatalogNodeAttributeDocument,
  DeleteJobCatalogNodeAttributeMutation,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import {
  formatUuidToNodeType,
  getChildNodeType,
  getNodeId,
  getNodeType,
} from 'modules/job_catalog/lib/nodesUtils'

const useDeleteJobCatalogNodeAttribute = () => {
  const [mutate, { loading }] = useMutation(DeleteJobCatalogNodeAttributeDocument, {
    extractorFn: (data: DeleteJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.deleteJobcatalogNodeAttribute,
  })

  const deleteAttribute = (id: string, nodeUuid: string) => {
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        id,
        nodeId: getNodeId(nodeUuid),
        nodeType: formatUuidToNodeType(getNodeType(nodeUuid)),
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid,
            childType,
          },
        },
      ],
    })
  }

  return { deleteAttribute, loading }
}

export default useDeleteJobCatalogNodeAttribute
